import { Component, Input } from '@angular/core';

@Component({
  template: '',
  selector: 'pui-list-item',
})
export class PuiListItemComponent {
  @Input() header: string;
  @Input() description: string;
  @Input() active = false;
  @Input() data: any;
}
